import { useCallback, useEffect, useState } from "react";

// Returns the window dimensions.
// If you are looking for whether we are on a mobile or not, refer to useDeviceDimensions instead.
export const useWindowDimensions = () => {
  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);

  const updateWindowSize = useCallback((e: any) => {
    setHeight(e.target.innerHeight);
    setWidth(e.target.innerWidth);
  }, []);

  useEffect(() => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);

    window.addEventListener("resize", updateWindowSize);
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, [updateWindowSize]);

  return {
    height,
    width,
  };
};
